export default function SectionedLayout({ children }) {
    return (
			<div className="bg-white ml-8 grid xl:grid-cols-8 grid-cols-7 h-full">
                {children}
            </div>
    )
}